import { gql } from "@apollo/client";

export default gql`
  query getLiveChatWidgetOverview{
    getLiveChatWidgetOverview{
        success
        data{
            config{
                bucket
                region
                prefix
                distributionId
                cdnUrl
                cacheControl
            }
            liveFiles{
                key
                size
                lastModified
                etag
            }
            liveTotalBytes
            activeRelease{
                _id
                version
                note
                status
                source
                restoredFrom
                bucket
                prefix
                archivePrefix
                distributionId
                cdnUrl
                files{
                    path
                    size
                    contentType
                }
                removedKeys
                invalidationId
                invalidationStatus
                healthCheckUrl
                healthCheckStatus
                errorMessage
                publishedBy
                createdAt
                updatedAt
            }
        }
        error
        message
    }
}
`
